import { useEffect } from "react";
import { createContext, useReducer, useState } from "react";




export const Adminauthcontext = createContext() // for User


export const Adminauthreducer = (state, action) => {
    switch (action.type) {
        case 'LOGIN':
            return { user: action.payload }
        case 'LOGOUT':
            return { user: null }
        default:
            return state;
    }
}



export const AdminAuthContextProvider = ({ children }) => {

    const [astate, adispatch] = useReducer(Adminauthreducer, {
        user: null,
    })
    const [Authloading, setLoading] = useState(true); // Add a loading state

    useEffect(() => {
        // Safely parse the user data
        const userData = sessionStorage.getItem('user');
        // const sessionTime = localStorage.getItem('expiryTime');
        // if (userData) {
        //     dispatch({ type: 'LOGIN', payload: userData });
        // }
        if (userData) {
            try {
                const parsedUser = userData;
                adispatch({ type: "LOGIN", payload: parsedUser });
            } catch (error) {
                console.error("Failed to parse user data from localStorage:", error);
            }
        }
        setLoading(false); // Finish initialization
    }, [])

    //console.log('AuthContext State: ', state);

    return (
        <Adminauthcontext.Provider value={{ ...astate, adispatch, Authloading}}>
            {children}
        </Adminauthcontext.Provider>
    )
}